import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "user-input" }
const _hoisted_2 = {
  key: 0,
  class: "block mb-2 text-xs font-semibold text-neutral-600"
}
const _hoisted_3 = {
  key: 0,
  class: "text-red-600"
}

import { computed } from 'vue';
import Multiselect from '@vueform/multiselect';
import debounce from "lodash/debounce";


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiSelect',
  props: {
    modelValue: {
        default: null,
        required: true
    },
    error: {
        type: String,
        default: null,
    },
    mode: {
        type: String,
        default: 'single' // single | multiple | tags
    },
    searchable: {
        type: Boolean,
        default: false
    },
    id: {
        type: String,
    },
    label: {
        type: String,
    },
    placeholder: {
        type: String,
        default: 'Placeholder'
    },
    disabled: {
        type: Boolean,
        default: false
    },
    canClear: {
        type: Boolean,
        default: false
    },
    required: {
        type: Boolean,
        default: false,
    },
    createOption: {
        type: Boolean,
        default: false,
    },
    readonly: {
        type: Boolean,
        default: false,
    },
    options: {
        type: Array,
        default: () => ([])
    }
},
  emits: ["update:modelValue", "handle:search"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit

const value = computed<object>({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit('update:modelValue', value);
    }
})

const test = debounce((val: string) => {
    emit('handle:search', val);
}, 1000)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
          _createTextVNode(_toDisplayString(__props.label) + " ", 1),
          (__props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(Multiselect), {
      mode: __props.mode,
      id: __props.id,
      name: _ctx.name,
      searchable: __props.searchable,
      placeholder: __props.placeholder,
      disabled: __props.disabled,
      options: __props.options,
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      onClear: _cache[1] || (_cache[1] = (value) => _ctx.$emit('update:modelValue', null)),
      class: _normalizeClass(["frm-multiselect py-[3px] bg-white", (__props.readonly ? 'pointer-events-none cursor-default' : '') || (__props.disabled ? 'bg-gray-100' : 'bg-white')]),
      required: __props.required,
      "can-clear": __props.canClear,
      "create-option": __props.createOption,
      onSearchChange: _unref(test)
    }, null, 8, ["mode", "id", "name", "searchable", "placeholder", "disabled", "options", "modelValue", "class", "required", "can-clear", "create-option", "onSearchChange"]),
    (__props.error)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          class: _normalizeClass(["text-[10px] mt-1", __props.error ? 'text-red-600' : 'text-gray-800']),
          id: "form-error"
        }, _toDisplayString(__props.error), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})